import { render } from "./PracticeChoice.vue?vue&type=template&id=08a175fa&scoped=true"
import script from "./PracticeChoice.vue?vue&type=script&lang=js"
export * from "./PracticeChoice.vue?vue&type=script&lang=js"

import "./PracticeChoice.vue?vue&type=style&index=0&id=08a175fa&scoped=true&lang=css"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a175fa"]])

export default __exports__